module.exports = __webpack_public_path__ + "static/media/ic-landing-problem.46b63b22.png";